import { AS_MOTOR_CLAIM_ROUTING_SET_VALUE } from "../../../actions/allSureMotorClaim/routing";
import { routingRules } from "./routing";


export const allSureMotorClaimRules = (store, next, action) => {
   if (action.type.startsWith(AS_MOTOR_CLAIM_ROUTING_SET_VALUE))
        return routingRules(store, next, action);

  return null;
};
